/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import {
    useOrderIsAuthorisedForTesting,
    useOrderIsTest,
    setOrderIsTest,
    setOrderMenu,
    useOrderMenu,
    useOrderAvailableMenus,
} from '@/hooks/api/order';

import { useMenus } from '@/hooks/api/menu';

const TestOrderControl = () => {
    const isAuthorisedForTesting = useOrderIsAuthorisedForTesting();
    const isTesting = useOrderIsTest();
    const orderMenu = useOrderMenu();
    const orderAvailableMenus = useOrderAvailableMenus();
    const orderAvailableMenuIds = orderAvailableMenus.map(menu => menu.id);
    const availableOverrideMenus = useMenus().filter(
        menu => !orderAvailableMenuIds.includes(menu.id)
    );

    const changeHandler = () => {
        setOrderIsTest(!isTesting);
    };

    const onMenuSelectChange = e => {
        const id = e.target.value;
        setOrderMenu({ id });
    };

    return (
        isAuthorisedForTesting && (
            <div className="m2g-test-order-control">
                <div className="m2g-test-order-control-header">Test Order</div>
                <div
                    className="m2g-test-order-control-toggle"
                    role="button"
                    tabIndex="0"
                    onKeyUp={() => {}}
                >
                    <input
                        type="checkbox"
                        checked={isTesting}
                        onChange={changeHandler}
                        className="m2g-test-order-control-toggle-checkbox"
                        id="m2g-test-order-control-checkbox"
                    />
                    <label
                        className="m2g-test-order-control-toggle-label"
                        role="button"
                        tabIndex="0"
                        htmlFor="m2g-test-order-control-checkbox"
                    >
                        Enabled
                    </label>
                </div>

                {isTesting && (
                    <div className="m2g-test-order-control-menu-override">
                        <label className="m2g-test-order-control-menu-override-label">
                            Menu Override
                        </label>
                        <div
                            className="m2g-input-container m2g-form-element-group"
                            data-icon-after="select"
                        >
                            <select
                                className="m2g-select m2g-select--primary m2g-form-element--full-width"
                                onChange={onMenuSelectChange}
                                value={orderMenu?.id}
                            >
                                <optgroup label="Default menus">
                                    {orderAvailableMenus.map(menu => {
                                        return (
                                            <option
                                                value={menu.id}
                                                key={menu.id}
                                            >
                                                {menu.backend_name}
                                            </option>
                                        );
                                    })}
                                </optgroup>
                                <optgroup label="Other menus">
                                    {availableOverrideMenus.map(menu => {
                                        return (
                                            <option
                                                value={menu.id}
                                                key={menu.id}
                                            >
                                                {menu.backend_name}
                                            </option>
                                        );
                                    })}
                                </optgroup>
                            </select>
                        </div>
                    </div>
                )}
            </div>
        )
    );
};

export default TestOrderControl;
